import styled, { css } from 'styled-components';
import { mixins } from '../../design-system';
import { tokens } from 'design-tokens/warwick/tokens';

const { space } = tokens.primitive;

export const Container = styled.div`
  display: flex;
  padding: ${space[9]} ${space[25]};
  ${mixins.surfaceNavBackground}
  width: fit-content;
  align-self: flex-end;
  margin-right: ${space[40]};
  margin-bottom: ${space[40]};
  > * + * {
    margin-inline-start: ${space[10]};
  }
`;

export const NavButton = styled.button`
  ${mixins.navButton}

  ${(props) =>
    props.active &&
    css`
      transform: scale(${tokens.semantic.size.nav.buttonScaleActive});
      background: ${tokens.semantic.color.background.rowActive};
    `}
`;

export const NotificationBadge = styled.span`
  ${mixins.notificationDot}
`;
